// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b017f783","239":"73528578","732":"51e8e522","977":"c1ae1fc2"}[chunkId] + ".chunk.js";
};